
import TransitionExpand from '@/transitions/TransitionExpand';

export default {
  name: 'AppToggleNotice',
  components: { TransitionExpand },
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  data: () => ({ isExpanded: false }),
  methods: {
    toggleNotice() {
      this.isExpanded = !this.isExpanded;
    }
  }
};
